import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquare, BarChart3, FileText, ArrowRight } from 'lucide-react';

export const ContactSection = ({ onContactClick }) => {
  const services = [
    {
      icon: MessageSquare,
      title: 'Beratungsgespräch',
      description: 'Kostenloses Erstgespräch mit unseren BESS-Spezialisten',
    },
    {
      icon: BarChart3,
      title: 'Systemanalyse',
      description:
        'Detaillierte Analyse Ihrer Infrastruktur und Energiedaten',
    },
    {
      icon: FileText,
      title: 'Individuelles Konzept',
      description: 'Maßgeschneidertes BESS-Konzept mit ROI-Berechnung',
    },
  ];

  return (
    <section id="contact" className="py-12 sm:py-20 bg-gradient-to-b from-background to-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
              Kontaktieren Sie uns:
            </p>
            <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
              Ihr Partner für BESS-Lösungen
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Von der Konzeption bis zur Inbetriebnahme – wir begleiten Ihr
              Rechenzentrum auf dem Weg zur energetischen Exzellenz. Unser
              Expertenteam entwickelt maßgeschneiderte BESS-Strategien für Ihre
              spezifischen Anforderungen.
            </p>
          </div>

          {/* Services Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {services.map((service, index) => (
              <Card
                key={index}
                className="group hover:shadow-lg transition-all duration-300 border-border hover:border-primary/30 hover:-translate-y-1"
              >
                <CardContent className="p-6 text-center flex flex-col h-full">
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary/20 transition-colors">
                    <service.icon className="w-8 h-8 text-primary" />
                  </div>

                  {/* Title */}
                  <h3 className="font-heading font-semibold text-xl text-foreground mb-3">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* CTA Section */}
          <Card className="border-2 border-primary/20 shadow-xl bg-gradient-to-br from-card to-muted">
            <CardContent className="p-8 md:p-12 text-center">
              <h3 className="font-heading font-bold text-3xl text-foreground mb-4">
                Bereit für die Energiezukunft?
              </h3>
              <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
                Lassen Sie uns gemeinsam die optimale BESS-Lösung für Ihr
                Rechenzentrum entwickeln. Kontaktieren Sie uns noch heute für
                ein unverbindliches Erstgespräch.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  size="lg"
                  className="group text-base px-8 shadow-md hover:shadow-lg"
                  onClick={onContactClick}
                >
                  Jetzt Beratung anfragen
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="text-base px-8"
                >
                  Mehr über uns erfahren
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};